import {useCallback, useState} from "react";

export const useModalState = (initialValue: boolean): [boolean, () => void, () => void] => {
    const [isModalOpen, setModalOpen] = useState(initialValue)

    const openModal = useCallback(() => setModalOpen(true), []);
    const closeModal = useCallback(() => setModalOpen(false), []);

    return [isModalOpen, openModal, closeModal]
}